export const ACCESS_CARE_SHEETS = 'AccessCareSheets';
export const ACCESS_LABELS = 'AccessLabels';
export const MANAGE_ARTICLES = 'ManageArticles';
export const MANAGE_LOGO = 'ManageLogo';
export const MANAGE_CARE_SHEET_ADS = 'ManageCareSheetAds';


/** WEBPACK FOOTER **
 ** ./src/modules/common/userPermissions.js
 **/